import React from 'react'

import { ErrorBoundary, ErrorScreen } from '../../components'
import UIRolloutAdminPage from '../pages/UIRolloutAdmin/UIRolloutAdminPage'
import { RedesignThemeProvider } from '../theme'

const AdminUIRolloutPreview = () => (
  <ErrorBoundary fallback={<ErrorScreen />}>
    <RedesignThemeProvider>
      <UIRolloutAdminPage />
    </RedesignThemeProvider>
  </ErrorBoundary>
)

export default AdminUIRolloutPreview
